import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=43166220&scoped=true&"
import script from "./Branding.vue?vue&type=script&lang=js&"
export * from "./Branding.vue?vue&type=script&lang=js&"
import style0 from "./Branding.vue?vue&type=style&index=0&id=43166220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43166220",
  null
  
)

export default component.exports